import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Initialize with 23h 59m 59s
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 md:space-x-4 text-white font-bold text-3xl md:text-5xl tracking-wider" data-id="element-262" data-mp="34tvgm00mluhz">
      <div className="flex flex-col items-center bg-oscuro/50 px-4 py-3 rounded-lg backdrop-blur-sm min-w-[80px] md:min-w-[100px]" data-id="element-263" data-mp="2c6lyhej1sa63">
        <span data-id="element-264" data-mp="2h8urubzu1e8q">{format(timeLeft.hours)}</span>
        <span className="text-xs md:text-sm font-normal text-gray-300 mt-1" data-id="element-265" data-mp="2l7tq5dr26cr7">
          HS
        </span>
      </div>
      <span className="text-oscuro/50 pb-6" data-id="element-266" data-mp="2q6dh5skieeqf">:</span>
      <div className="flex flex-col items-center bg-oscuro/50 px-4 py-3 rounded-lg backdrop-blur-sm min-w-[80px] md:min-w-[100px]" data-id="element-267" data-mp="2q52a9jvroqv3">
        <span data-id="element-268" data-mp="1xhzidalljedt">{format(timeLeft.minutes)}</span>
        <span className="text-xs md:text-sm font-normal text-gray-300 mt-1" data-id="element-269" data-mp="1xgodf7gf00l4">
          MIN
        </span>
      </div>
      <span className="text-oscuro/50 pb-6" data-id="element-270" data-mp="22g127xqujhqc">:</span>
      <div className="flex flex-col items-center bg-oscuro/50 px-4 py-3 rounded-lg backdrop-blur-sm min-w-[80px] md:min-w-[100px]" data-id="element-271" data-mp="279ca827ea4ju">
        <span data-id="element-272" data-mp="19r3swk4m4v9q">{format(timeLeft.seconds)}</span>
        <span className="text-xs md:text-sm font-normal text-gray-300 mt-1" data-id="element-273" data-mp="1erhpn60rkisg">
          SEG
        </span>
      </div>
    </div>;
}